import { render, staticRenderFns } from "./Create-Job.vue?vue&type=template&id=354ac464"
import script from "./Create-Job.vue?vue&type=script&lang=js"
export * from "./Create-Job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports